// import axios from "axios";
import api from "./apiConfig";



export const getAllInvoices = async (data) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const invoicesCall = await api.get('/invoices', { params: data, headers: { 'x-auth-token': localStorage.getItem('token') } })
            // console.log(invoicesCall);   
            let status = invoicesCall?.data?.status;
            let successData = invoicesCall?.data?.data;
            let message = invoicesCall?.data.message;

            if (status !== 200) {
                resolve([{ message, status }, null])
            } else {
                resolve([null, successData])


            }
        } catch (error) {
            resolve([{ message: error, status: 500 }, null])
        }
    })
}


export const getSingleInvoices = async (data) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const invoicesCall = await api.get(`/invoices/${data.id}`, { params: {} })
            // console.log(invoicesCall);   
            let status = invoicesCall?.data?.status;
            let successData = invoicesCall?.data?.data;
            let message = invoicesCall?.data.message;

            if (status !== 200) {
                resolve([{ message, status }, null])
            } else {
                resolve([null, successData])


            }
        } catch (error) {
            resolve([{ message: error, status: 500 }, null])
        }
    })
}


export const createInvoice = async (data) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const invoicesCall = await api.post('/invoices', data, {
                headers: { 'x-auth-token': localStorage.getItem('token') }
            });

            const status = invoicesCall?.data?.status;
            const successData = invoicesCall?.data?.data;
            const message = invoicesCall?.data.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }
        } catch (error) {
            reject(error);
        }
    });
};



export const updateInvoice = async (invoice) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const invoiceId = invoice.id || invoice._id;
            const response = await api.put(`/invoices/${invoiceId}`, {
                ...invoice,
            },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-auth-token': localStorage.getItem('token')
                    },
                }
            )

            // console.log(response)
            let status = response?.data?.status;
            let successData = response?.data?.data;
            let message = response?.data?.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }
        } catch (error) {
            console.error('Error updating invoice:', error);
            throw error;
        }
    })
};

export const deleteInvoice = async (invoiceId) => {
    return await new Promise(async (resolve, reject) => {
        try {
            const response = await api.delete(`/invoices/${invoiceId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth-token': localStorage.getItem('token')
                },
            });
            // console.log(response)
            let status = response?.data?.status;
            let successData = response?.data?.data;
            let message = response?.data?.message;

            if (status !== 200) {
                resolve([{ message, status }, null]);
            } else {
                resolve([null, successData]);
            }
        } catch (error) {
            console.error('Error deleting invoice:', error);
            reject(error);

        }
    })
};


export const getTotalInvoices = async () => {
    try {
        const response = await api.get(`/invoices/total`, {
            headers: { 'x-auth-token': localStorage.getItem('token') }
        });

        return response.data.message.total;
    } catch (error) {
        throw error;
    }
};

export const getInvoiceSummaryStats = async () => {
    try {
        const response = await api.get(`/invoices/summary-stats`, {
            headers: { 'x-auth-token': localStorage.getItem('token') }
        });
        return response.data.data;
    } catch (error) {
        throw error;
    }
};


export const getMonthlyInvoiceCount = async () => {
    try {
        const response = await api.get('/invoices/monthly-count', {
            headers: { 'x-auth-token': localStorage.getItem('token') }
        });
        return response.data.data; // Return the aggregated data
    } catch (error) {
        console.error("Error fetching monthly invoice count:", error);
        return [];
    }
};


export const getPaymentInvoice = async (reference) => {
    try {
        const response = await api.get(`/invoices/verify-payment/${reference}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching invoice verification:", error);
        throw error;
    }
};


export const sendPaymentLink = async (invoice) => {
    try {
        const invoiceId = invoice.id || invoice._id;
        const response = await api.post(`/invoices/send-payment-link/${invoiceId}`, {
            customer_email: invoice.customer_email,
        });

        return [null, response.data];
    } catch (error) {
        console.error('Error sending payment link:', error);
        return [{ message: error.message, status: error.response?.status }, null];
    }
};


export const sendReceipt = async (invoice) => {
    try {
        const invoiceId = invoice.id || invoice._id;
        const response = await api.post(`/invoices/send-receipt/${invoiceId}`, {
            customer_email: invoice.customer_email,
        });

        return [null, response.data];
    } catch (error) {
        console.error('Error sending payment receipt:', error);
        return [{ message: error.message, status: error.response?.status }, null];
    }
};






